import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect } from 'react'
import AnimateHeight from 'react-animate-height'
import fetchApiError from '../../../Helpers/fetchApiError'
import { useForm } from '../../../Hooks/useForm'
import TrackingService from '../../../Services/Tracking'
import './styles.scss'

const Tracker = ({ setTrackItResult }) => {
  const { form, onChange, reset } = useForm({
    trackingNumber: '',
    loading: false,
    error: null,
  })

  useEffect(() => {
    return reset
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getDetails = async (num) => {
    onChange('loading', true)
    onChange('error', null)

    try {
      const res = await TrackingService.get_by_tracking_number(num)
      setTrackItResult(res.data.data)
    } catch (error) {
      setTrackItResult(null)
      onChange('error', fetchApiError(error))
    }

    onChange('loading', false)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    getDetails(form.trackingNumber)
  }

  return (
    <div className="tracker-card">
      <div className="tracker-card__icon-wrap">
        <img src="/favicon.png" alt="Dove Global Logistics" />
      </div>

      <h2 className="tracker-card__title">Track Your Shipment</h2>
      <p className="tracker-card__subtitle">
        Enter your airway bill or tracking number to get real-time updates.
      </p>

      <form onSubmit={handleSubmit} className="tracker-card__form">
        <div className="tracker-card__input-wrap">
          <FontAwesomeIcon className="search-icon" icon={solid('magnifying-glass')} />
          <input
            type="text"
            placeholder="e.g. DGL-0001234"
            value={form.trackingNumber}
            onChange={(e) => onChange('trackingNumber', e.target.value)}
            required
            autoFocus
          />
        </div>

        <AnimateHeight duration={300} height={form.error ? 'auto' : 0}>
          <div className="tracker-card__error">
            <FontAwesomeIcon icon={solid('circle-exclamation')} />
            {form.error}
          </div>
        </AnimateHeight>

        <button
          type="submit"
          className="tracker-card__btn"
          disabled={form.loading || !form.trackingNumber.trim()}
        >
          {form.loading ? (
            <FontAwesomeIcon icon={solid('circle-notch')} spin />
          ) : (
            <>
              <FontAwesomeIcon icon={solid('magnifying-glass')} />
              Track Shipment
            </>
          )}
        </button>
      </form>

      <p className="tracker-card__hint">
        <FontAwesomeIcon icon={solid('circle-info')} />
        Your tracking number can be found on your shipment receipt or confirmation email.
      </p>
    </div>
  )
}

export default Tracker
